// extracted by mini-css-extract-plugin
module.exports = {"container":"DeliveryLabel_container__0lYez","button":"DeliveryLabel_button__Un4Ds","tommorow":"DeliveryLabel_tommorow__DdmK_"};